<script>
import wallet from '../store/wallet';

export default {
  name   : 'WalletBalance',
  filters: {
    balanceValue(value) {
      // nullなら既定値を使用。数値があれば区切りが入るようにして返却
      return value == null ? '－' : value.toLocaleString();
    },
  },
  computed: {
    wallet: function() {
      return this.$store.state.wallet || {};
    },
  },
  beforeMount: function() {
    if (!this.$store.state.wallet) {
      this.$store.registerModule('wallet', wallet);
    }
    this.fetchWallet().catch(this.onError);
  },
  methods: {
    fetchWallet() {
      return this.$store.dispatch('wallet/fetchWallet');
    },
    onError(error) {
      this.$emit('error', error);
    },
  },
};
</script>
